import { ApiHandler, DekError, saveToApiLog } from '@eshop/api-client'

import { Config } from '#/global/helper/Config'
import '#/global/helper/DataLayer/dataLayerHelper'

interface ExponeaDataLayer {
    event: string
    exponea: string[]
}

const EXPONEA_ANALYSIS_ID_HP = '6682bb8f11e5033d357e8f6f'

const EXPONEA_ANALYSIS_ID: Record<string, string> = {
    // Stavebniny
    3: '667bfe4bed72c377f239df32',
    // Elektromateriál
    5: '667bfe7edb522e854d477246',
    // Nářadí
    6: '667bfed80d7c5faafbdb4b93',
    // Voda Topení Sanita
    22: '667bfe7edb522e854d477240',
    // Barvy a tapety
    31: '667bfc511995e7a169eae95c',
}

const getAnalysisId = (sectionId?: string) => sectionId === undefined ? EXPONEA_ANALYSIS_ID_HP : EXPONEA_ANALYSIS_ID[sectionId]

export const getProductCodeListFromDataLayer = async (sectionId?: string) => {
    const dataLayer = await tryFindDataLayer(sectionId ? `lastVisitedProductsAtSection_${sectionId}` : 'lastVisitedProductsAll')
    return dataLayer.exponea.filter(x => x !== 'None') ?? []
}

export const getFillOutProductCodeList = async (sectionId?: string) => {
    const analysisId = getAnalysisId(sectionId)
    if (!analysisId) {
        return []
    }

    const api = new ApiHandler({
        path: '/product/get-best-seller-product-code-eshop-list',
        parameters: {
            analysisId,
        },
    })

    api.addResponseHandler('4xx', async response => api.handleError({
        customMessage: message(response.status),
        hideMessage: !Config.isDevelopment(),
    })).addResponseHandler('5xx', async response => api.handleError({
        customMessage: message(response.status),
        hideMessage: !Config.isDevelopment(),
    }))

    const productList = await api.send()

    // remove duplicates
    return [...new Set(productList)]
}

const message = (status: number) => `Nastala neočekávaná chyba při načítání produktů pro ReactProductSliderUserTarget. (${status})`

const tryFindDataLayer = async (event: string) => {
    const maxTimeout = 10_000 // 10s
    const now = Date.now()

    if (window.dataLayer === undefined) {
        console.warn(`[ReactProductSliderUserTarget]: dataLayer not found`)
        return { event, exponea: [] }
    }

    const exponeaDataLayer = window.dataLayer.find((x: ExponeaDataLayer) => x.event === event) as ExponeaDataLayer

    if (exponeaDataLayer !== undefined) {
        return exponeaDataLayer
    }

    let timeoutExpired = false

    return new Promise<ExponeaDataLayer>((resolve) => {
        // pokud se nepodaří najít event v dataLayeru včas (10s), tak se vrátí prázdný objekt
        const timeout = setTimeout(() => {
            timeoutExpired = true
            console.warn(`[ReactProductSliderUserTarget]: dataLayer event '${event}' not found`)
            resolve({ event, exponea: [] })
        }, maxTimeout)

        // eslint-disable-next-line no-new
        new DataLayerHelper(window.dataLayer, {
            listener: (_dataLayer, item) => {
                if ('event' in item && (item as { event: any }).event === event) {
                    console.debug(`[ReactProductSliderUserTarget]: dataLayer event '${event}' found in ${Date.now() - now}ms`)
                    clearTimeout(timeout)
                    if (timeoutExpired) {
                        void saveToApiLog(new DekError(`[ReactProductSliderUserTarget]: dataLayer event '${event}' found in ${Date.now() - now}ms`))
                    }
                    resolve(item as ExponeaDataLayer)
                }
            },
            listenToPast: true,
        })
    })
}
